<script setup lang="ts">
import MyMenusIcon from '@/assets/icons/Menus/MyMenusIcon.vue';
import type { MessageSchema } from '@/i18n/index.js';
import SpeedDial from 'primevue/speeddial';
import { markRaw, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits<{
  (e: 'show-import-dialog'): void;
}>();

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });

const importMenuItems = ref([
  {
    label: t('menu.import.label'),
    icon: 'pi pi-upload',
    customIcon: markRaw(MyMenusIcon),
    command: () => {
      emit('show-import-dialog');
    },
  },
]);
</script>
<template>
  <div>
    <SpeedDial
      :model="importMenuItems"
      :radius="120"
      type="linear"
      direction="up"
      class="!fixed right-8 text-white"
      :style="{ bottom: 'calc(6rem + var(--safe-area-inset-bottom, 0px))' }"
      :pt="{
        root: { style: { 'align-items': 'flex-end' } },
        menu: { style: { 'align-items': 'flex-end' } },
      }"
    >
      <template #item="{ item, onClick }">
        <button
          class="my-1 flex items-center justify-end gap-3 rounded-full bg-surface-600 px-4 py-3 text-white hover:bg-surface-700"
          @click="onClick"
        >
          <p class="font-content text-sm text-white">{{ item.label }}</p>
          <component :is="item.customIcon" class="h-4 w-4 text-white" />
        </button>
      </template>
    </SpeedDial>
  </div>
</template>
